var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.12146L9.41302 9.04608C11.9387 10.48 13.0613 10.48 15.587 9.04608L22.5 5.12146",
    stroke: "#FF7E6B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.6215C10.5337 19.6154 10.0668 19.6065 9.59883 19.5947C6.45033 19.5156 4.87608 19.476 3.74496 18.3399C2.61383 17.2038 2.58114 15.6702 2.51577 12.6029C2.49475 11.6166 2.49474 10.6362 2.51576 9.64989C2.58114 6.58259 2.61382 5.04894 3.74495 3.91285C4.87608 2.77676 6.45033 2.73719 9.59882 2.65804C11.5393 2.60926 13.4607 2.60927 15.4012 2.65805C18.5497 2.7372 20.1239 2.77678 21.255 3.91287C22.3862 5.04895 22.4189 6.5826 22.4842 9.6499C22.4939 10.104 22.4991 10.318 22.4999 10.6215",
    stroke: "#FF7E6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.1215C19.5 17.9499 18.8284 18.6215 18 18.6215C17.1716 18.6215 16.5 17.9499 16.5 17.1215C16.5 16.2931 17.1716 15.6215 18 15.6215C18.8284 15.6215 19.5 16.2931 19.5 17.1215ZM19.5 17.1215V17.6215C19.5 18.4499 20.1716 19.1215 21 19.1215C21.8284 19.1215 22.5 18.4499 22.5 17.6215V17.1215C22.5 14.6362 20.4853 12.6215 18 12.6215C15.5147 12.6215 13.5 14.6362 13.5 17.1215C13.5 19.6068 15.5147 21.6215 18 21.6215",
    stroke: "#FF7E6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/Email_Icon.26b79193e7c7eccb724cd1a0f5c92b4a.svg";
export { ForwardRef as ReactComponent };